import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/** Fullscreen hero video: parallax + Ken Burns; vertical cut on phones, horizontal elsewhere. */
export default function HeroVideo({ poster, verticalPoster, strength = 14 }) {
  const ref = useRef(null);
  const [mobile, setMobile] = useState(
    () => window.matchMedia("(max-width: 767px)").matches
  );

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
  const scale = 1 + (strength * 2 + 12) / 100;

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // iOS only autoplays when the muted attribute is present before load: arm it explicitly
  const armVideo = (el) => {
    if (!el || el.dataset.armed) return;
    el.dataset.armed = "1";
    el.setAttribute("muted", "");
    el.muted = true;
    el.defaultMuted = true;
    const tryPlay = () => el.play().catch(() => {});
    el.addEventListener("loadedmetadata", tryPlay, { once: true });
    el.addEventListener("canplay", tryPlay, { once: true });
    el.load();
    tryPlay();
  };

  const sources = mobile
    ? { webm: "/video/hero_verticale.webm", mp4: "/video/hero_verticale.mp4" }
    : { webm: "/video/hero.webm", mp4: "/video/hero.mp4" };

  return (
    <div ref={ref} className="absolute inset-0 h-full overflow-hidden">
      <div className="kenburns absolute inset-0">
        <motion.div
          style={{ y, scale, transformOrigin: "center" }}
          className="absolute inset-0 will-change-transform"
        >
          <video
            key={mobile ? "verticale" : "orizzontale"}
            poster={mobile ? verticalPoster : poster}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            disablePictureInPicture
            aria-hidden="true"
            data-testid="hero-video"
            data-variant={mobile ? "verticale" : "orizzontale"}
            ref={armVideo}
            className="h-full w-full object-cover"
          >
            <source src={sources.webm} type="video/webm" />
            <source src={sources.mp4} type="video/mp4" />
          </video>
        </motion.div>
      </div>
    </div>
  );
}
